import React from "react";
import "../styles/Footer.css";

const Footer = () => {
    return (
        <footer className="flex items-center justify-center gap-2.5 bg-[#f7f9fa]">
            <div className="flex flex-col w-full items-start gap-12 p-10 bg-[#f7f9fa]">
                <div className="flex items-start justify-between self-stretch w-full flex-[0_0_auto]">
                    <div className="flex flex-col items-start gap-3 self-stretch w-[700px] flex-[0_0_auto]">
                        <p className="self-stretch mt-[-1.00px] text-heading-s font-bold text-gray-800">
                            고객센터
                        </p>

                        <p className="self-stretch font-medium text-gray-800 text-xl">
                            오전 09시 ~ 오후 18시 (주말, 공휴일 제외)
                        </p>
                        <p className="self-stretch font-normal text-gray-800 text-lg">
                            이메일 : oracle7579@gmail.com
                        </p>
                        <p className="self-stretch font-normal text-gray-800 text-lg">
                            전화번호 : 010-5502-9714
                        </p>
                    </div>

                    <div className="w-full inline-flex justify-between items-start flex-[0_1_auto]">
                        <div className="flex flex-col items-start gap-6">
                            <p className="self-stretch mt-[-1.00px] font-semibold text-gray-600 text-title-xxs">
                                Information
                            </p>

                            <div className="flex flex-col items-start gap-3 self-stretch w-full flex-[0_0_auto] text-gray-600 text-label-s font-medium">
                                <a className="self-stretch" href="/privacy-policy">
                                    개인정보 처리방침
                                </a>
                                <a className="self-stretch" href="/term-of-use">서비스 이용 약관</a>
                            </div>
                        </div>
                    </div>
                    <div className="w-full inline-flex justify-between items-start flex-[0_1_auto]">
                        <div className="flex flex-col items-start gap-6">
                            <p className="self-stretch mt-[-1.00px] font-semibold text-gray-600 text-title-xxs">
                                Information
                            </p>

                            <div className="flex flex-col items-start gap-3 self-stretch w-full flex-[0_0_auto] text-gray-600 text-label-s font-medium">
                                <a className="self-stretch" href="/about">
                                    회사 소개
                                </a>
                                <a className="self-stretch" href="/service">고객지원</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col items-start gap-6 self-stretch w-full flex-[0_0_auto]  text-gray-600 text-label-xs font-medium">
                    <div className="flex flex-col items-start gap-2 self-stretch w-full flex-[0_0_auto]">
                        <p className="w-full ">
                            <span className="w-fit mt-[-1.00px] mr-4 whitespace-nowrap">
                                소프트캣
                            </span>

                            <span className="w-fit mt-[-1.00px] mr-2 whitespace-nowrap">
                                대표 : 박찬엽
                            </span>

                            <span className="w-fit mt-[-1.00px] mr-4">
                                주소 : 경기도 고양시 덕양구 원흥3로 16 904호
                            </span>
                        </p>

                        <div className="inline-flex items-center gap-[35px]  flex-[0_0_auto]">
                            <p className="w-fit mt-[-1.00px] text-gray-600 whitespace-nowrap ">
                                사업자 등록번호 : 292-56-00756
                            </p>

                            <p className="w-fit mt-[-1.00px] text-gray-600 whitespace-nowrap ">
                                통신판매업 신고번호 : 2025-고양덕양구-0992호
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
